import Wv3dPropertiesPanel from './Wv3dPropertiesPanelContainer';

export default Wv3dPropertiesPanel;
